export default __webpack_public_path__ + "static/media/Muneeb Butt.e1c790a1.jpg";